import { EligibilitySupportOtherRelativesScreen } from "@/interactors/EligibilitySupportOtherRelativesScreen";

export default function SupportOtherRelatives() {
  return <EligibilitySupportOtherRelativesScreen />;
}
